/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

import { htmlSafe } from '@ember/template';

export default class PhIcon extends Component {
  // icon is the name of the icon used
  icon = '';

  // only styles imported are bold and duotone. duotone by default.
  style = 'duotone';

  // icon size in px. default to 32px
  @tracked size = '32';

  // styles outputs the inline styles for the component
  get styles() {
    return htmlSafe(`font-size: ${this.size}px`);
  }
}
